__turbopack_context__.v({
  "centered": "Input-module__ZhDbXq__centered",
  "head": "Input-module__ZhDbXq__head",
  "incrementalButton": "Input-module__ZhDbXq__incrementalButton",
  "input": "Input-module__ZhDbXq__input",
  "inputContainer": "Input-module__ZhDbXq__inputContainer",
  "inputDisabled": "Input-module__ZhDbXq__inputDisabled",
  "inputError": "Input-module__ZhDbXq__inputError",
  "inputIcon": "Input-module__ZhDbXq__inputIcon",
  "inputIconAsButton": "Input-module__ZhDbXq__inputIconAsButton",
  "inputUnit": "Input-module__ZhDbXq__inputUnit",
  "inputWrapper": "Input-module__ZhDbXq__inputWrapper",
  "inputWrapperSmall": "Input-module__ZhDbXq__inputWrapperSmall",
  "inputWrapperWithIncrementalButtons": "Input-module__ZhDbXq__inputWrapperWithIncrementalButtons",
  "labelDetail": "Input-module__ZhDbXq__labelDetail",
  "textError": "Input-module__ZhDbXq__textError",
  "wrapper": "Input-module__ZhDbXq__wrapper",
});
